var React = require('react');

function Footer (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"288","height":"199","fill":"white","key":0}),React.createElement("rect",{"y":"151","width":"288","height":"48","fill":"#737373","key":1}),React.createElement("rect",{"x":"16","width":"256","height":"135","fill":"#D8D8D8","key":2})]);
}

Footer.defaultProps = {"width":"288","height":"199","viewBox":"0 0 288 199","fill":"none"};

module.exports = Footer;

Footer.default = Footer;
